<template>
  <div class="header">
    <!-- 顶部栏 -->
    <div class="common-nav">
      <div class="common-nav__container">
        <div class="common-nav__left">
          <div class="common-nav__navigation-title">
            电子产业一站式服务平台
            <img src="@/assets/common/header/header_arrow.svg" class="arrow-img">
          </div>
          <div class="common-nav__navigation-menu">
            <div class="navigation-menu-supply">
              <div class="navigation-menu-title">供应链服务</div>
              <ul class="navigation-menu-supply__ul">
                <li>
                  <a :href="`https://${linkEnv}www.hqpcb.com/quote`" target="_blank" class="navigation-menu-supply__link">
                    <div class="supply-link-logo">
                      <img src="@/assets/common/header/huaqiu-logo.png" class="img-logo">
                    </div>
                    <div class="supply-link-content">
                      <p class="supply-link-title">华秋PCB</p>
                      <p class="supply-link-desc">高可靠多层板制造商</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a :href="`https://${linkEnv}smt.hqchip.com/`" target="_blank" class="navigation-menu-supply__link need_add_hqsource">
                    <div class="supply-link-logo">
                      <img src="@/assets/common/header/huaqiu-logo.png" class="img-logo">
                    </div>
                    <div class="supply-link-content">
                      <p class="supply-link-title">华秋SMT</p>
                      <p class="supply-link-desc">高可靠一站式PCBA智造商</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a :href="`https://${linkEnv}www.hqchip.com/`" target="_blank" class="navigation-menu-supply__link need_add_hqsource">
                    <div class="supply-link-logo">
                      <img src="@/assets/common/header/huaqiu-logo.png" class="img-logo">
                    </div>
                    <div class="supply-link-content">
                      <p class="supply-link-title">华秋商城</p>
                      <p class="supply-link-desc">自营现货电子元器件商城</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a :href="`https://${linkEnv}www.hqpcb.com/hqpcblayout.html`" target="_blank" class="navigation-menu-supply__link">
                    <div class="supply-link-logo">
                      <img src="@/assets/common/header/huaqiu-logo.png" class="img-logo">
                    </div>
                    <div class="supply-link-content">
                      <p class="supply-link-title">PCB Layout</p>
                      <p class="supply-link-desc">高多层、高密度产品设计</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a :href="`https://${linkEnv}www.hqpcb.com/stencil/quote.html`" target="_blank" class="navigation-menu-supply__link">
                    <div class="supply-link-logo">
                      <img src="@/assets/common/header/huaqiu-logo.png" class="img-logo">
                    </div>
                    <div class="supply-link-content">
                      <p class="supply-link-title">钢网制造</p>
                      <p class="supply-link-desc">专注高品质钢网制造</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a :href="`https://${linkEnv}www.hqchip.com/bom.html`" target="_blank" class="navigation-menu-supply__link need_add_hqsource">
                    <div class="supply-link-logo">
                      <img src="@/assets/common/header/huaqiu-logo.png" class="img-logo">
                    </div>
                    <div class="supply-link-content">
                      <p class="supply-link-title">BOM配单</p>
                      <p class="supply-link-desc">专业的一站式采购解决方案</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a :href="`https://${linkEnv}www.hqdoc.com/`" target="_blank" class="navigation-menu-supply__link">
                    <div class="supply-link-logo">
                      <img src="@/assets/common/header/huaqiu-logo.png" class="img-logo">
                    </div>
                    <div class="supply-link-content">
                      <p class="supply-link-title">华秋认证</p>
                      <p class="supply-link-desc">认证检测无可置疑</p>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <div class="navigation-menu-supply enginer">
              <div class="navigation-menu-title">工程师工具</div>
                <ul class="navigation-menu-supply__ul">
                    <li>
                        <a :href="`https://${linkEnv}dfm.hqpcb.com/`" target="_blank"
                            class="navigation-menu-supply__link need_add_hqsource need_insert_env_prefix">
                            <div class="supply-link-logo">
                                <img src="@/assets/common/header/dfm.png" class="img-logo">
                            </div>
                            <div class="supply-link-content">
                                <p class="supply-link-title">华秋DFM</p>
                                <p class="supply-link-desc">一键分析设计隐患</p>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a href="https://kicad.eda.cn/" target="_blank"
                            class="navigation-menu-supply__link need_insert_env_prefix">
                            <div class="supply-link-logo">
                                <img src="@/assets/common/header/kicad.png" class="img-logo">
                            </div>
                            <div class="supply-link-content">
                                <p class="supply-link-title">KiCad 华秋发行版 ^9.0</p>
                                <p class="supply-link-desc">集成AI Copilot</p>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.eda.cn/ecadViewer" target="_blank"
                            class="navigation-menu-supply__link need_insert_env_prefix">
                            <div class="supply-link-logo">
                                <img src="@/assets/common/header/xinlin.png" class="img-logo">
                            </div>
                            <div class="supply-link-content">
                                <p class="supply-link-title">EDA在线查看器</p>
                                <p class="supply-link-desc">SCH、PCB、BOM、3D模型</p>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.eda.cn/" target="_blank"
                            class="navigation-menu-supply__link need_insert_env_prefix">
                            <div class="supply-link-logo">
                                <img src="@/assets/common/header/xinlin.png" class="img-logo">
                            </div>
                            <div class="supply-link-content">
                                <p class="supply-link-title">DataSheet资料查询</p>
                                <p class="supply-link-desc">最全面的元器件搜索引擎</p>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a href="https://p.eda.cn/" target="_blank"
                            class="navigation-menu-supply__link need_insert_env_prefix">
                            <div class="supply-link-logo">
                                <img src="@/assets/common/header/huaqiu-logo.png" class="img-logo">
                            </div>
                            <div class="supply-link-content">
                                <p class="supply-link-title">开源硬件平台</p>
                                <p class="supply-link-desc">最新的、经过验证的开源硬件项目</p>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
          </div>
        </div>
        <div class="common-nav__right">
          <!-- 登录内容 -->
          <div v-if="userInfo && userInfo.sso_uid" class="common-nav__user-login hide-logout">
            <a class="user-title" target="_blank" :href="`${hqchipUrl}/mycenter/`">
              <span class="user-info">{{ userInfo.username }} ({{ userInfo.sso_uid }}) </span>
              <img src="@/assets/common/header/header_arrow.svg" class="arrow-img">
            </a>
            <div class="user-menu">
              <a class="user-menu__item" :href="`${hqchipUrl}/mycenter/finance/balance/index`" ><i class="el-icon-s-finance"></i>我的余额</a>
              <a class="user-menu__item" href="/users/logout?back="><i class="el-icon-switch-button"></i>退出</a>
            </div>
          </div>
          <div v-else class="common-nav__user ">
            <a href="javascript:void(0)" @click="setDialogSwitch(0)" class="user-reg">登录</a>
            <a href="javascript:void(0)" @click="setDialogSwitch(1)" class="user-login">注册</a>
          </div>
          <div class="common-nav__diver hide-logout"></div>
          <!-- 我的订单 -->
          <div class="common-nav__my-order">
            <a class="my-order-title" :href="`${hqchipUrl}/mycenter/order/smt/list`">
              我的订单
              <img src="@/assets/common/header/header_arrow.svg" class="arrow-img">
            </a>
            <div class="my-order-menu">
              <a class="my-order-menu__item" target="_blank" :href="`${hqchipUrl}/mycenter/order/pcb/list`" >PCB订单</a>
              <a class="my-order-menu__item" target="_blank" :href="`${hqchipUrl}/mycenter/order/ic/list`" >元器件订单</a>
              <a class="my-order-menu__item" target="_blank" :href="`${hqchipUrl}/mycenter/order/pcba/list/new`" >PCBA订单</a>
              <a class="my-order-menu__item" target="_blank" :href="`${hqchipUrl}/mycenter/order/smd/list`" >钢网订单</a>
              <a class="my-order-menu__item" target="_blank" :href="`${hqchipUrl}/mycenter/order/layout/list`" >Layout订单</a>
              <a class="my-order-menu__item" target="_blank" :href="`${hqchipUrl}/mycenter/order/smt/list`" >SMT订单</a>
            </div>
          </div>
          <div class="common-nav__diver"></div>
          <!-- 下单帮助 -->
          <div class="common-nav__order-help">
            <a class="order-help-title" :href="`https://${linkEnv}www.hqpcb.com/help`">
              下单帮助
              <img src="@/assets/common/header/header_arrow.svg" class="arrow-img">
            </a>
            <div class="order-help-menu">
              <a class="order-help-menu__item" target="_blank" :href="`https://www.hqpcb.com/orderstep.html`" >下单流程</a>
              <a class="order-help-menu__item" target="_blank" :href="`https://${linkEnv}www.hqpcb.com/pay.html`" >付款方式</a>
              <a class="order-help-menu__item" target="_blank" :href="`https://${linkEnv}www.hqpcb.com/guestbook`" >常见问题</a>
              <a class="order-help-menu__item" target="_blank" :href="`https://${linkEnv}www.hqpcb.com/help`" >更多帮助</a>
            </div>
          </div>
          <!-- <div class="common-nav__diver"></div> -->
          <!-- 客服电话 -->
          <!-- <div class="common-nav__phone">
            <img src="@/assets/common/header/header_phone.svg" class="phone-img"><span class="phone-number">0755-83688678</span>
          </div> -->
        </div>
      </div>
    </div>
    <!-- 导航栏 -->
    <HeaderNav />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderNav from './components/HeaderNav.vue'

export default {
  components: {
    HeaderNav,
  },
  computed: {
    // 用户信息
    ...mapGetters('orderUser', [
      'userInfo',
    ]),
    // PCB站点
    hqchipUrl() {
      return process.env.VUE_APP_HQCHIP_URL
    },
    // 登录、注册返回url
    backAct() {
      return encodeURIComponent(location.href)
    },
    // 区分跳转链接环境
    linkEnv() {
      return {
        'development': 'fat-',
        'fat': 'fat-',
        'uat': 'uat-',
      }[process.env.NODE_ENV] || ''
    }
  },
  data() {
    return {
      showDialog: false,
      dialogSwitch: 0
    }
  },
  methods: {
    setDialogSwitch(type) {
      this.$smtLogin({
        isShow: true,
        dialogSwitch: type
      })
      //判断点击的 登录|注册
      // this.dialogSwitch = type
      // this.showDialog = !this.showDialog;
    }
  }
}
</script>

<style lang="scss" scoped>
// 顶部栏
.common-nav {
	height: 32px;
	background: #3C4043;
	font-size: 13px;
	color: #f2f2f2;
  .common-nav__container {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;
  }
  .common-nav__left {
    position: relative;
  }
  .common-nav__right {
    display: flex;
  }
  /* 左边导航内容 */
  .common-nav__navigation-title {
    display: block;
    width: auto;
    height: 32px;
      padding-left: 2px;
    line-height: 32px;
    color: #f2f2f2;
      user-select: none;
  }
  .common-nav__navigation-title .arrow-img {
    width: auto;
    transition: all 0.2s;
  }
  .common-nav__left:hover .arrow-img {
    transform: rotate(180deg);
  }
  .common-nav__navigation-menu {
    position: absolute;
    display: flex;
    width: 488px;
    padding: 3px 0;
    border: 1px solid #555555;
    border-radius: 0 0 4px 4px;
    border-top-color: #fff;
    background: #fff;
    box-shadow: 2px 2px 4px 0px rgba(0,0,0,0.2);
    z-index: 1100;
    visibility: hidden;
    transition-delay: 0.15s;
  }
  .common-nav__left:hover .common-nav__navigation-menu {
    visibility: visible;
  }
  .navigation-menu-supply {
    margin-left: 25px;
    width: 200px;
  }
  .navigation-menu-supply.enginer {
    width: 220px;
  }
  .navigation-menu-supply__ul {
    padding-top: 18px;
  }
  .navigation-menu-supply__ul li{
    margin-bottom: 19px;
  }
  .navigation-menu-supply__link {
    display: flex;
  }
  .navigation-menu-supply__link .supply-link-logo {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }
  .navigation-menu-supply__link .img-logo {
    width: 26px;
    height: 26px;
  }
  .navigation-menu-supply__link .supply-link-content {
    width: auto;
  }
  .navigation-menu-supply__link .supply-link-title {
    font-size: 13px;
    font-weight: bold;
    color: #333;
  }
  .navigation-menu-supply__link:hover .supply-link-title {
    color: #c00;
  }
  .navigation-menu-supply__link .supply-link-desc {
    font-size: 12px;
    color: #999;
  }

  .navigation-menu-title {
    height: 48px;
    line-height: 48px;
    font-size: 15px;
    color: #333;
    border-bottom: 1px solid #ebebeb;
  }
  /* 用户登录注册 */
  .common-nav__user {
    margin-right: 15px;
      font-size: 0;
  }
  .common-nav__user .user-login,
  .common-nav__user .user-reg {
    display: inline-block;
    width: 48px;
      font-size: 13px;
    text-align: center;
    line-height: 32px;
    color: #f2f2f2;
  }
  .common-nav__user .user-login:hover,
  .common-nav__user .user-reg:hover {
    background: #333333;;
  }
  .common-nav__user .user-jd {
    display: inline-block;
    width: 56px;
    height: 16px;
    line-height: 16px;
    margin-top: 7px;
    border: 1px solid #e6a23c;
    border-radius: 3px;
    font-size: 12px;
    text-align: center;
    color: #e6a23c;
    background: #fcf5eb;
  }
  .common-nav__user-login {
    position: relative;
    text-align: center;
  }
  .common-nav__user-login .user-title{
    display: block;
    width: auto;
    padding: 0 8px;
    height: 32px;
    line-height: 32px;
    color: #f2f2f2;
  }
  .common-nav__user-login:hover .user-title {
    background: #333333;
  }
  .common-nav__user-login .arrow-img {
    width: auto;
    transition: all 0.2s;
  }
  .common-nav__user-login:hover .arrow-img {
    transform: rotate(180deg);
  }
  .common-nav__user-login .user-menu {
    position: absolute;
    left: 0;
    right: 0;
    padding: 3px 0;
    border: 1px solid #555555;
    border-radius: 0 0 4px 4px;
    border-top-color: #fff;
    background: #fff;
    box-shadow: 2px 2px 4px 0px rgba(0,0,0,0.2);
    z-index: 1100;
    visibility: hidden;
    transition-delay: 0.15s;
  }
  .common-nav__user-login:hover .user-menu {
    visibility: visible;
  }
  .common-nav__user-login .user-menu__item {
    display: block;
    height: 32px;
    line-height: 32px;
    text-align: left;
    padding-left: 10px;
    color: #333333;
  }
  .common-nav__user-login .user-menu__item i{
      font-size: 14px;
      margin-right: 5px;
  }
  .common-nav__user-login .user-menu__item:hover {
    background: #F5F7FA;
  }
  /* 我的订单和下单帮助样式 */
  .common-nav__order-help,
  .common-nav__my-order {
    position: relative;
    width: 90px;
    text-align: center;
  }

  .common-nav__order-help .order-help-title,
  .common-nav__my-order .my-order-title {
    display: block;
    width: 90px;
    height: 32px;
    line-height: 32px;
    color: #f2f2f2;
  }
  .common-nav__order-help:hover .order-help-title,
  .common-nav__my-order:hover .my-order-title {
    background: #333333;
  }
  .common-nav__order-help .arrow-img,
  .common-nav__my-order .arrow-img {
    width: auto;
    transition: all 0.2s;
  }
  .common-nav__order-help:hover .arrow-img,
  .common-nav__my-order:hover .arrow-img {
    transform: rotate(180deg);
  }
  .common-nav__order-help .order-help-menu,
  .common-nav__my-order .my-order-menu {
    position: absolute;
    padding: 3px 0;
    width: 88px;
    border: 1px solid #555555;
    border-radius: 0 0 4px 4px;
    border-top-color: #fff;
    background: #fff;
    box-shadow: 2px 2px 4px 0px rgba(0,0,0,0.2);
    z-index: 1100;
    visibility: hidden;
    transition-delay: 0.15s;
  }
  .common-nav__order-help:hover .order-help-menu,
  .common-nav__my-order:hover .my-order-menu {
    visibility: visible;
  }
  .common-nav__order-help .order-help-menu__item,
  .common-nav__my-order .my-order-menu__item {
    display: block;
    height: 32px;
    line-height: 32px;
    padding-left: 10px;
    text-align: left;
    color: #333333;
  }
  .common-nav__order-help .order-help-menu__item:hover,
  .common-nav__my-order .my-order-menu__item:hover {
    background: #F5F7FA;
  }
  /* 通用分割符 */
  .common-nav__diver {
    margin: 9px 4px;
    width: 1px;
    background: #7f7f7f;
  }
  /* 右侧手机号码 */
  .common-nav__phone {
    line-height: 32px;
    margin-left: 12px;
  }
  .common-nav__phone .phone-img{
    vertical-align: middle;
      margin-top: -3px;
  }
  .common-nav__phone .phone-number{
    margin-left: 8px;
  }
}
</style>